import { render } from "./DialogErro.vue?vue&type=template&id=1cc87150"
import script from "./DialogErro.vue?vue&type=script&lang=js"
export * from "./DialogErro.vue?vue&type=script&lang=js"

import exportComponent from "X:\\GRV\\CPS5\\Projetos\\CPSDashApontamento\\apontamentowebvueV3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__